import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { BASE_URL, OG_IMAGE } from '../utils/seo';
import { enterUp } from '../utils/animations';
import { AdamStory } from '../components/about/AdamStory';
import { VALeverage } from '../components/about/VALeverage';
import { MissionSection } from '../components/about/MissionSection';
import { CoreValues } from '../components/about/CoreValues';
import { PullQuote } from '../components/about/PullQuote';
import { PageCTA } from '../components/PageCTA';

export default function About() {
    return (
        <div data-testid="about-page">
            <Helmet>
                <title>About - White Glove Hiring | Built by Adam Cothes</title>
                <meta name="description" content="White Glove Hiring was built by Adam Cothes - a top-producing real estate agent selling $50-60M a year. The system he built to solve his own VA problems became the program." />
                <meta property="og:title" content="About White Glove Hiring | Built by Adam Cothes" />
                <meta property="og:description" content="Built in the field, not a conference room. Adam Cothes needed this system to exist - and couldn't find anything good enough." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={`${BASE_URL}/about`} />
                <meta property="og:image" content={OG_IMAGE} />
                <link rel="canonical" href={`${BASE_URL}/about`} />
            </Helmet>

            <section className="bg-navy-900 hero-pattern pt-36 pb-20">
                <div className="max-w-7xl mx-auto px-6 lg:px-12">
                    <motion.div {...enterUp}>
                        <p className="text-gold-400 text-xs font-bold tracking-[0.3em] uppercase font-inter mb-4">The Founder</p>
                        <h1 className="font-montserrat font-black text-4xl md:text-5xl lg:text-6xl text-white tracking-tight leading-tight max-w-4xl">
                            This Wasn't Built in a Conference Room. It Was Built in the Field.
                        </h1>
                        <p className="text-gray-300 text-lg mt-5 max-w-2xl leading-relaxed">
                            White Glove Hiring exists because Adam Cothes needed it to exist - and couldn't find anything good enough.
                        </p>
                    </motion.div>
                </div>
            </section>

            <AdamStory />
            <VALeverage />
            <MissionSection />
            <CoreValues />
            <PullQuote />

            <PageCTA
                headline="Want to Talk to the Person Who Built This?"
                sub="Adam takes diagnostic calls personally. One conversation, no pressure."
                testId="about-cta"
            />
        </div>
    );
}
